import { openProfessionalNPS } from './modals'
import { useEffect } from 'react'
import {
  checkDoctorNpsEligible,
  getCurrentDoctorId,
  isProfessionalNpsClosedThisSession,
} from 'ui/ProfessionalNPS/services'

/** Set to true to open NPS every time you land on a private page (for debugging). */
const NPS_ALWAYS_OPEN = false

/**
 * Mounted alongside every private route. Triggers modals that should run on
 * any authenticated page (e.g. Professional NPS), not just one specific route.
 */
export function PrivateRouteModals(): null {
  useEffect(() => {
    let cancelled = false

    const maybeOpenNps = async () => {
      if (NPS_ALWAYS_OPEN) {
        openProfessionalNPS()
        return
      }

      const doctorId = getCurrentDoctorId()
      if (!doctorId) return

      if (isProfessionalNpsClosedThisSession()) return

      try {
        const isEligible = await checkDoctorNpsEligible(doctorId)
        if (cancelled || !isEligible) return
        openProfessionalNPS()
      } catch {
        // Silent fail: NPS should not block route rendering.
      }
    }

    maybeOpenNps()

    return () => {
      cancelled = true
    }
  }, [])

  return null
}
